import { Utilities as utilities } from "@truckdown/framework";
import { ChangeLog } from "./ChangeLog";
import { ClientRestrictionStatus } from "./ClientRestrictionStatus";
import { RestrictionType } from "./RestrictionType";

export class Restriction {
    constructor(json?: any) {
        if (json) {
            this.key = utilities.json.getStringValue(json, "_id", '');
            this.type = utilities.json.getEnumValue(json, "t", RestrictionType, RestrictionType.IpAddress);
            this.category = utilities.json.getStringValue(json, "cat", '');
            this.countryCode = utilities.json.getStringValue(json, "cc", '');
            this.status = utilities.json.getEnumValue(json, "s", ClientRestrictionStatus, ClientRestrictionStatus.None);

            if (utilities.data.isDate(json.lt, true)) {
                this.lastTriggered = utilities.json.getDateValue(json, 'lt');
            }

            this.modifiedDate = utilities.json.getDateValue(json, 'mt', new Date());
            this.createdTime = utilities.json.getDateValue(json, 'ct', new Date());

            if (utilities.data.isDate(json.exp, true)) {
                this.expiry = utilities.json.getDateValue(json, 'exp');
            }

            this.changeLog = utilities.json.getArrayValue(json, (itm) => { return new ChangeLog(itm); }, 'cl', []);
        }
    }

    toJSON() {
        return {
            _id: this.key,
            t: this.type,
            cat: this.category,
            cc: this.countryCode,
            s: this.status,
            lt: this.lastTriggered,
            mt: this.modifiedDate,
            ct: this.createdTime,
            exp: this.expiry,
            cl: this.changeLog
        };
    }

    key: string = '';
    type: RestrictionType = RestrictionType.IpAddress;
    category: string = '';
    countryCode: string = '';
    status: ClientRestrictionStatus = ClientRestrictionStatus.None;
    lastTriggered?: Date;
    modifiedDate: Date = new Date();
    createdTime: Date = new Date();
    expiry?: Date;
    changeLog: ChangeLog[] = [];
}